import { CertificationStatus, OrderMeasuresTypes } from '../enums';

export interface ICertificationAssetDto {
    url: string;
    timestamp: string;
    comment?: string;
}

export interface ItemCertificationOutputDto {
    type: OrderMeasuresTypes;
    value: number;
}

export interface OrderMeasureOutputDto {
    type: OrderMeasuresTypes;
    value: number;
}

export interface ICertificationItemsOutputDto {
    orderItemId: string;
    certifications: ItemCertificationOutputDto[];
    subStatus?: string;
    weightEdited?: boolean;
}

export interface ISubStatusDto {
    id: string;
    value: string;
}

export interface ICertifiedByDto {
    driver?: string;
    userId: string;
    name: string;
}

class ICertificationReferenceDto {
    order?: string;
    trip?: string;
    checkpointIndex?: number;
}

export interface IUpdatedByDto {
    userId: string;
    name: string;
}

export interface ICertificationOutputDto {
    id: string;
    ref: ICertificationReferenceDto;
    certifiedAt: string;
    certifiedBy?: ICertifiedByDto;
    status: CertificationStatus;
    subStatus?: ISubStatusDto;
    description?: string;
    photos: ICertificationAssetDto[];
    signatures: ICertificationAssetDto[];
    comments?: Omit<ICertificationAssetDto, 'url'>[];
    items?: ICertificationItemsOutputDto[];
    orderMeasures?: OrderMeasureOutputDto[];
    updatedBy?: IUpdatedByDto;
    createdAt: string;
}
